import {data_data_integrity_map} from "./data-integrity";

export const data_seasons_map = {
    '': {
        label: "Season"
    },
    'spring': {
        label: "Spring"
    },
    'summer': {
        label: "Summer"
    },
    'fall': {
        label: "Fall"
    },
    'winter': {
        label: "Winter"
    },
}

export const data_seasons_arr = Object.entries(data_seasons_map).map(([k, v]) => {
    return {
        value: k,
        label: v.label
    }
});